import { z } from "zod";

export const account = z.object({
  firebaseId: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
});

export type Account = z.infer<typeof account>;
